import React, { useState } from 'react';
import {
  ErrorMessage, Field, Form, Formik,
} from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import closeEyeIcon from '../../assets/icons/eyeClose.svg';
import openEyeIcon from '../../assets/icons/eyeOpen.svg';
import ValidationSchema from '../../helpers/ValidationSchema';
import closeIcon from '../../assets/icons/closeIcon.svg';
import useWindowSize from '../../hooks/useWindowSize';
import { changeUserPassword } from '../../store/actions/userAccount';
import { expiredAction } from '../../store/actions/expiredAction';
import Spinner from '../../components/Spinner';

function AccountPassword({ handleCloseMenu }) {
  const { width } = useWindowSize();
  const dispatch = useDispatch();
  const [openPassword, setOpenPassword] = useState(true);
  const { changePassword } = ValidationSchema();
  const [currentPasswordError, setCurrentPasswordError] = useState('');
  const lang = Cookies.get('i18next') || 'en';
  const { translations } = useSelector((state) => state.translation);
  const [loading, setLoading] = useState(false);
  const handleChangePassword = async (values) => {
    setLoading(true);
    const { payload } = await dispatch(changeUserPassword({ ...values, lang }));
    if (payload.status === 'error') {
      if (payload.message === 'Token is Expired') {
        dispatch(expiredAction(true));
      }
    } else if (payload.message === 'Current password is incorrect') {
      setCurrentPasswordError(payload.message);
    } else {
      toast(payload.message);
    }
    setLoading(false);
  };
  return (
    <div className="account__profile password">
      <div className="account__profile-top">
        <div className="account__profile-top-mobile">
          <h2 className="account__profile-top-title">{translations.profile_password[lang]}</h2>
          {width < 768
              && (
              <button onClick={handleCloseMenu} type="button">
                <img
                  className="account-close-icon"
                  src={closeIcon}
                  alt=""
                />
              </button>
              )}
        </div>
      </div>
      <Formik
        initialValues={{
          current_password: '',
          new_password: '',
          new_password_confirmation: '',
        }}
        onSubmit={async (values) => {
          await handleChangePassword(values);
        }}
        validationSchema={changePassword}
      >
        {({ setFieldValue }) => (
          <Form className="register-form user">
            <div className="register-form-group password">
              <label className="inputs-label" htmlFor="current_password">{translations.old_password_label[lang]}</label>
              <div className="register-form-group_input input-block">
                <Field
                  onChange={(e) => {
                    setFieldValue('current_password', e.target.value);
                    setCurrentPasswordError('');
                  }}
                  as="input"
                  type={openPassword ? 'password' : 'text'}
                  name="current_password"
                  id="current_password"
                  placeholder={translations.old_password_placeholder[lang]}
                />
                <button className="password-eye" type="button" onClick={() => setOpenPassword(!openPassword)}>
                  <img
                    src={openPassword ? closeEyeIcon : openEyeIcon}
                    alt="eye"
                  />
                </button>
                {currentPasswordError && <p className="authError">{currentPasswordError}</p>}
              </div>
              <ErrorMessage
                name="current_password"
                component="p"
                className="authError"
              />
            </div>
            <div className="register-form-group password">
              <label className="inputs-label" htmlFor="new_password">{translations.password_label[lang]}</label>
              <div className="register-form-group_input input-block">
                <Field
                  type={openPassword ? 'password' : 'text'}
                  as="input"
                  name="new_password"
                  id="new_password"
                  placeholder={translations.password_placeholder[lang]}
                />
                <button className="password-eye" type="button" onClick={() => setOpenPassword(!openPassword)}>
                  <img
                    src={openPassword ? closeEyeIcon : openEyeIcon}
                    alt="eye"
                  />
                </button>
              </div>
              <ErrorMessage
                name="new_password"
                component="p"
                className="authError"
              />
            </div>
            <div className="register-form-group password">
              <label className="inputs-label" htmlFor="new_password_confirmation">{translations.confirm_password_label[lang]}</label>
              <div className="register-form-group_input input-block">
                <Field
                  as="input"
                  type={openPassword ? 'password' : 'text'}
                  name="new_password_confirmation"
                  id="new_password_confirmation"
                  placeholder={translations.confirm_password_placeholder[lang]}
                />
                <button className="password-eye" type="button" onClick={() => setOpenPassword(!openPassword)}>
                  <img
                    src={openPassword ? closeEyeIcon : openEyeIcon}
                    alt="eye"
                  />
                </button>
              </div>
              <ErrorMessage
                name="new_password_confirmation"
                component="p"
                className="authError"
              />
            </div>
            <button type="submit" className="change-profile-btn password">
              {!loading ? (
                <>
                  <div className="change-profile-icon" />
                  <p>{translations.change_password[lang]}</p>
                </>
              ) : (
                <Spinner isBtn size={30} minWidth={150} />
              )}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default AccountPassword;
